import { useContext } from "react";

import { actions } from "../context/AppProvider";
import appContext from "../context/appContext";

const MobileMenuItems = () => {
    const { state, dispatch } = useContext(appContext);

    return (
        <div className="mobileMenuItems">
            <button
                className="button"
                style={{ width: "100%" }}
                onClick={() => {
                    dispatch({ type: actions.RETURN_TO_START });
                }}
            >
                Start Over
            </button>
            <div />
            <button
                className={"button" + (state.selectedGeos.length === 0 ? " buttonDisabled" : "")}
                style={{ width: "100%" }}
                disabled={state.selectedGeos.length === 0}
                onClick={() => {
                    dispatch({ type: actions.SET_IS_DOWNLOAD_MODAL_OPEN, to: true });
                }}
            >
                Download
            </button>
        </div>
    );
};
export default MobileMenuItems;
